import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  ylSku: '',
  brandId: '',
  goodsName: '',
  //商品分类
  goodsTypeIdFirst: '',
  goodsTypeIdSecond: '',
  goodsTypeId: '',
  goodsNo: '',
  //店内分类
  storeGoodsTypeFirst: '',
  storeGoodsTypeId: '',
  goodsModel: '',
  priceRange: {
    start: '',
    end: ''
  },
  stockRange: {
    start: '',
    end: ''
  },
  shelfTimeRange: {
    start: '',
    end: ''
  },
  goodsStatus: 1
};
import comGoodStock from './goodStock.vue';
import { cloneDeep } from 'lodash';
export default {
  meta: {
    title: '在售商品管理',
    auth: true,
    authorityValue: "store-onshelf-manage"
  },
  name: 'saleTrade',
  components: {
    comGoodStock: comGoodStock
  },
  data: function data() {
    return {
      brandList: [],
      initForm: initForm,
      form: cloneDeep(initForm),
      request: {
        api: 'goodsList',
        params: cloneDeep(initForm)
      },
      layer: {
        show: false,
        title: '选择商品分类',
        showButton: true
      },
      layer2: {
        show: false,
        title: '总库存',
        showButton: true,
        form: {
          x: 0
        },
        width: '800px'
      },
      multipleSelection: [],
      props: {
        label: 'typeName',
        value: 'goodsTypeId',
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      checked: false,
      typeOptions: [],
      typeOptions2: [],
      typeOptions3: [],
      brandOptions: [],
      storeTypeOptions: [],
      storeTypeOptions2: [],
      storeTypeOptions3: [],
      storeTypeOptions4: [],
      dialogVisible: false,
      setForm: {
        goodsIds: [],
        storeGoodsTypeFirst: '',
        storeGoodsTypeId: ''
      }
    };
  },
  mounted: function mounted() {
    this.searchBrandsOptions();
    this.getGoodsTypes();
    this.storeGoodsTypes();
  },
  methods: {
    searchBrandsOptions: function searchBrandsOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$api$bra, records;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.brands();

              case 2:
                _yield$_this$$api$bra = _context.sent;
                records = _yield$_this$$api$bra.records;
                _this.brandList = records;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getGoodsTypes: function getGoodsTypes(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_this2$$api$go, records;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.goodsTypes(_objectSpread(_objectSpread({}, item), {}, {
                  pageSize: 999,
                  typeLevel: 1
                }));

              case 2:
                _yield$_this2$$api$go = _context2.sent;
                records = _yield$_this2$$api$go.records;
                _this2.typeOptions = records;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    storeGoodsTypes: function storeGoodsTypes(item) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$_this3$$api$st, records;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$api.storeGoodsTypes(_objectSpread(_objectSpread({}, item), {}, {
                  pageSize: 999,
                  typeLevel: 1
                }));

              case 2:
                _yield$_this3$$api$st = _context3.sent;
                records = _yield$_this3$$api$st.records;
                _this3.storeTypeOptions = records;
                _this3.storeTypeOptions3 = records;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleChange: function handleChange(e) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$_this4$$api$go, records;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$api.goodsTypes({
                  pageSize: 999,
                  preTypeId: e[0]
                });

              case 2:
                _yield$_this4$$api$go = _context4.sent;
                records = _yield$_this4$$api$go.records;
                _this4.typeOptions2 = records;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleChange2: function handleChange2(e) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$_this5$$api$go, records;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.$api.goodsTypes({
                  pageSize: 999,
                  preTypeId: e[0]
                });

              case 2:
                _yield$_this5$$api$go = _context5.sent;
                records = _yield$_this5$$api$go.records;
                _this5.typeOptions3 = records;

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handleStoreChange: function handleStoreChange(e) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$_this6$$api$st, records;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this6.$api.storeGoodsTypes({
                  pageSize: 999,
                  preTypeId: e[0]
                });

              case 2:
                _yield$_this6$$api$st = _context6.sent;
                records = _yield$_this6$$api$st.records;
                _this6.storeTypeOptions2 = records;

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 批量设置店内分类
    handleStoreChange3: function handleStoreChange3(e) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$_this7$$api$st, records;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('e3', e);
                _context7.next = 3;
                return _this7.$api.storeGoodsTypes({
                  pageSize: 999,
                  preTypeId: e[0]
                });

              case 3:
                _yield$_this7$$api$st = _context7.sent;
                records = _yield$_this7$$api$st.records;
                _this7.storeTypeOptions4 = records;
                _this7.setForm.storeGoodsTypeFirst = e[0];

                if (_this7.storeTypeOptions4 == []) {
                  _this7.setForm.storeGoodsTypeId = '';
                }

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    handleStoreChange4: function handleStoreChange4(e) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('e4', e);
                _this8.setForm.storeGoodsTypeId = e[0];

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    handleSet: function handleSet() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log('setForm', _this9.setForm);
                _context9.next = 3;
                return _this9.$api.updateStoreType(_objectSpread({}, _this9.setForm));

              case 3:
                _this9.dialogVisible = false;
                YL.message('修改成功');
                _this9.form.storeGoodsTypeFirst = '';
                _this9.form.storeGoodsTypeId = '';

                _this9.handleSearch(_this9.form);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.storeGoodsTypes();
      this.storeTypeOptions4 = [];
      this.setForm.goodsIds = []; // this.storeTypeOptions3 = []
      // this.storeTypeOptions4 = []
    },
    handleSearch: function handleSearch(values) {
      var params = values;

      if (values.goodsTypeIdFirst.length > 0 && Array.isArray(values.goodsTypeIdFirst)) {
        this.$set(values, 'goodsTypeIdFirst', params.goodsTypeIdFirst[0]);
      }

      if (values.goodsTypeIdSecond.length > 0 && Array.isArray(values.goodsTypeIdSecond)) {
        this.$set(values, 'goodsTypeIdSecond', params.goodsTypeIdSecond[0]);
      }

      if (values.goodsTypeId.length > 0 && Array.isArray(values.goodsTypeId)) {
        this.$set(values, 'goodsTypeId', params.goodsTypeId[0]);
      }

      if (values.storeGoodsTypeFirst.length > 0 && Array.isArray(values.storeGoodsTypeFirst)) {
        this.$set(values, 'storeGoodsTypeFirst', params.storeGoodsTypeFirst[0]);
      }

      if (values.storeGoodsTypeId.length > 0 && Array.isArray(values.storeGoodsTypeId)) {
        this.$set(values, 'storeGoodsTypeId', params.storeGoodsTypeId[0]);
      }

      if (values.brandId.length > 0 && Array.isArray(values.brandId)) {
        this.$set(values, 'brandId', params.brandId[0]);
      }

      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },
    openEditGoodsSlogan: function openEditGoodsSlogan(row) {
      var _this10 = this;

      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.$prompt('请输入商品标语', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '名称不为空',
          type: 'success'
        }).then( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref) {
            var value;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    value = _ref.value;

                    _this10.multipleSelection.forEach( /*#__PURE__*/function () {
                      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(v) {
                        return regeneratorRuntime.wrap(function _callee10$(_context10) {
                          while (1) {
                            switch (_context10.prev = _context10.next) {
                              case 0:
                                _context10.next = 2;
                                return _this10.$api.saveGoods({
                                  goodsId: v.goodsId,
                                  goodsSlogan: value
                                });

                              case 2:
                                return _context10.abrupt("return", _context10.sent);

                              case 3:
                              case "end":
                                return _context10.stop();
                            }
                          }
                        }, _callee10);
                      }));

                      return function (_x2) {
                        return _ref3.apply(this, arguments);
                      };
                    }());

                    YL.message('修改成功');

                    _this10.handleSearch(_this10.form);

                  case 4:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    },
    openEditGoodsName: function openEditGoodsName(row) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var res;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _this11.$api.goodsDetails({
                  goodsId: row.goodsId
                });

              case 2:
                res = _context13.sent;

                _this11.$prompt('请输入商品名称', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputPattern: /\S/,
                  inputErrorMessage: '名称不为空'
                }).then( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref4) {
                    var value, sellAttributes, params;
                    return regeneratorRuntime.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            value = _ref4.value;
                            sellAttributes = res.sellAttributeList.map(function (v) {
                              return _objectSpread(_objectSpread({}, v), {}, {
                                items: v.items.map(function (m) {
                                  return {
                                    sellAttributeId: v.sellAttributeId,
                                    sellAttributeItemId: m.sellAttributeItemId,
                                    itemValue: m.itemValue,
                                    itemSort: m.itemSort,
                                    selected: m.validItemIds.length > 0
                                  };
                                })
                              });
                            });
                            params = _objectSpread(_objectSpread({}, res), {}, {
                              sellAttributes: sellAttributes,
                              goodsId: row.goodsId,
                              goodsName: value
                            });
                            _context12.next = 5;
                            return _this11.$api.saveGoods(params);

                          case 5:
                            YL.message('修改成功');

                            _this11.handleSearch(_this11.form);

                          case 7:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12);
                  }));

                  return function (_x3) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    clickOpenLayer2: function clickOpenLayer2(row) {
      this.layer2.show = true;
      this.layer2.form = row;
    },
    confirm2: function confirm2() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _this12.$refs.comGoodStock.onSubimt();

              case 2:
                _this12.layer2.show = false;
                YL.message('修改成功');

                _this12.handleSearch(_this12.form);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },
    clickOpenLayer: function clickOpenLayer(row) {
      this.layer.show = true;
      this.layer.goodsId = row.goodsId;
    },
    changeCascader: function changeCascader(e) {
      var _this13 = this;

      var arr = ['goodsTypeIdFirst', 'goodsTypeIdSecond', 'goodsTypeId'];
      arr.forEach(function (v, i) {
        return _this13.layer[v] = e[i];
      });
    },
    lazyLoad: function lazyLoad(node, resolve) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var level, data, obj, _yield$_this14$$api$g, records;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                level = node.level, data = node.data;
                obj = {
                  typeLevel: level + 1,
                  preTypeId: data === null || data === void 0 ? void 0 : data.goodsTypeId
                };
                _context15.next = 4;
                return _this14.$api['goodsTypes'](obj, resolve);

              case 4:
                _yield$_this14$$api$g = _context15.sent;
                records = _yield$_this14$$api$g.records;
                resolve(records);

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    },
    clickCopyLink: function clickCopyLink(e) {
      YL.copyThat(e.goodsNo);
    },
    clickOffAll: function clickOffAll() {
      var _this15 = this;

      if (this.multipleSelection && this.multipleSelection.length <= 0) {
        return YL.message('请选择需要下架的商品', 'error');
      }

      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.$confirm('确定批量下架么?', '提示', {
          type: 'warning'
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
          var params;
          return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  _context16.prev = 0;
                  params = {
                    goodsIds: [],
                    goodsStatus: 2
                  };

                  _this15.multipleSelection.forEach(function (v) {
                    params.goodsIds.push(v.goodsId);
                  });

                  _context16.next = 5;
                  return _this15.$api.onShelf(_objectSpread({}, params));

                case 5:
                  // this.multipleSelection.forEach(async v => await this.$api.onShelf({ goodsId: v.goodsId }))
                  YL.message('下架成功');

                  _this15.handleSearch(_this15.form);

                  _context16.next = 12;
                  break;

                case 9:
                  _context16.prev = 9;
                  _context16.t0 = _context16["catch"](0);
                  YL.message(_context16.t0, 'error');

                case 12:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, null, [[0, 9]]);
        })));
      }
    },
    clickSet: function clickSet() {
      var _this16 = this;

      if (this.multipleSelection && this.multipleSelection.length <= 0) {
        return YL.message('请选择需要批量设置的商品', 'error');
      }

      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.multipleSelection.forEach(function (v) {
          _this16.setForm.goodsIds.push(v.goodsId);
        });
        console.log('this.multipleSelection', this.multipleSelection);
        this.dialogVisible = true; // this.goRoute('tabTrade', { goodsIds: JSON.stringify(goodsIds) })
      }
    },
    clickAllSelection: function clickAllSelection(e) {
      var _this17 = this;

      if (e) {
        this.tableData.forEach(function (v) {
          return _this17.$refs.multipleTable.toggleRowSelection(v);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.multipleSelection = e;
    },
    confirm: function confirm() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var params, arr, key;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                params = {};
                arr = ['goodsTypeIdFirst', 'goodsTypeIdSecond', 'goodsTypeId', 'goodsId'];
                arr.forEach(function (v) {
                  return params[v] = _this18.layer[v];
                });
                _context17.t0 = regeneratorRuntime.keys(params);

              case 4:
                if ((_context17.t1 = _context17.t0()).done) {
                  _context17.next = 11;
                  break;
                }

                key = _context17.t1.value;

                if (params[key]) {
                  _context17.next = 9;
                  break;
                }

                if (key == 'goodsTypeIdFirst') _this18.$message.error('请选择分类');else if (key == 'goodsTypeIdSecond') _this18.$message.error('请选择二级分类');else if (key == 'goodsTypeId') _this18.$message.error('请选择三级分类');
                return _context17.abrupt("return");

              case 9:
                _context17.next = 4;
                break;

              case 11:
                _context17.next = 13;
                return _this18.$api.updateType(params);

              case 13:
                YL.message('成功迁移');
                _this18.layer.show = false;

                _this18.handleSearch(_this18.form);

              case 16:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }))();
    },
    offShelf: function offShelf(row) {
      var _this19 = this;

      this.$confirm('确定下架么?', '提示', {
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return _this19.$api.onShelf({
                  goodsId: row.goodsId
                });

              case 2:
                YL.message('下架成功');

                _this19.handleSearch(_this19.form);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      })));
    }
  }
};